var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3872fb8f3d12dfb8d55d632f116e2033db0aa862"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["magic-accounts-app@pluslabs"]={id:"3872fb8f3d12dfb8d55d632f116e2033db0aa862"};
      